const Utility = {

    once_class(elements: Array<HTMLElement> | NodeListOf<Element>, klass: string): Array<HTMLElement> {
        if (Array.isArray(elements)) {
            return elements.filter((i) => {
                if (i.classList.contains(klass)) {
                    return false;
                }
                i.classList.add(klass);
                return true;
            });
        } else {
            let results: Array<HTMLElement> = [];
            elements.forEach(el => {
                if (!el.classList.contains(klass)) {
                    results.push(el as HTMLElement);
                }
            })
            results.forEach(i => i.classList.add(klass));
            return results;
        }
    },
    loaderHtml(prompt: string): string {
        return "<p>Proszę czekać. " + prompt + "</p>";
    },
    errorHtml(prompt: string): string {
        return "<p>Wystąpił błąd. " + prompt + "</p>";
    },

    isOnlyDigits(text: string) {
        return /^[0-9\.\,]+$/.test(text);
    }

}
export default Utility